<template>
    <div class="comment-page">
        <div class="heading">
            <span>Enviar</span>
            <span class="font-weight-bold">Sugestão</span>
        </div>

        <div class="to">
            Enviar para:

            <div class="chips">
                <div class="chip-wrapper" v-if="establishment.name">
                    <v-chip class="font-weight-light"
                            @click="to = establishment.id"
                            :selected="to === establishment.id">
                        {{establishment.name}}
                    </v-chip>
                </div>

                <div class="chip-wrapper" v-if="advertiser.name">
                    <v-chip class="font-weight-light"
                            @click="to = advertiser.id"
                            :selected="to === advertiser.id">
                        {{advertiser.name}}
                    </v-chip>
                </div>
            </div>
        </div>

        <div class="message">
            Sugestão:

            <v-textarea solo
                        auto-grow
                        v-model="message"></v-textarea>
        </div>

        <div class="footer">
            <button class="btn font-weight-light" @click="send">
                Enviar
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                to: null,
                message: null
            }
        },

        props: {
            preview: {
                type: Boolean,
                required: true
            }
        },

        computed: {
            userHash() {
                if (this.preview)
                    return null

                return this.$store.state.user.userHash
            },

            interaction() {
                if (this.preview)
                    return null

                return this.$store.state.interaction.interaction
            },

            establishment() {
                if (!this.interaction)
                    return false

                return {
                    id: this.interaction.estabelecimentoId,
                    name: this.interaction.estabelecimentoNome,
                }
            },

            advertiser() {
                if (!this.interaction)
                    return false

                return {
                    id: this.interaction.anuncianteId,
                    name: this.interaction.anuncianteNome,
                }
            },
        },

        methods: {
            async send() {
                if (this.preview)
                    return this.$emit('sent')

                const data = {
                    usuarioAlvoId: this.to,
                    comentario: this.message,
                    hash: this.userHash
                }

                try {
                    await this.$api.interaction.comment(data)
                    this.$emit('sent')
                } catch (e) {
                    console.log(e)
                }
            }
        },

        mounted() {
            this.to = this.establishment.id
        }
    }
</script>

<style lang="scss" scoped>
    .comment-page {
        display: grid;
        grid-template-rows: 1fr 1fr 3fr 1fr;
        padding: 14px;
        color: #313131;
        background-color: white;
        position: absolute;
        width: 100%;
        height: inherit;

        .heading {
            display: flex;
            flex-direction: column;

            span {
                font-size: 28px;
                line-height: 24px;
            }
        }

        .to {
            .chips {
                margin: 14px 20px;
                display: flex;
                align-items: center;
                justify-content: space-around;
                flex-wrap: wrap;

                .chip-wrapper {
                    text-align: center;
                    min-width: 50%;

                    > * {
                        /*font-size: 16px;*/
                        /*border: .5px solid #707070;*/
                    }
                }
            }
        }

        .message {
            > *:last-child {
                padding: 10px;
            }
        }

        .footer {
            display: flex;
            align-items: center;
            justify-content: center;

            .btn {
                background-color: green;
                color: white;
                border-radius: 12px;
                font-size: 17px;
                padding: 7px 30px;
            }
        }
    }
</style>
